/**
 * Returns true when a Convex error carries the given error code.
 * Convex wraps `ConvexError({ code })` under the `.data` property of the thrown object.
 */
export function isConvexErrorWithCode(err: unknown, code: string): boolean {
  if (typeof err !== 'object' || err === null) return false
  const data = (err as { data?: unknown }).data
  return typeof data === 'object' && data !== null && (data as { code?: string }).code === code
}
